const Logo = (props) => (
  <img
    alt="Logo"
    src="/static/logo.png"
    height="25px"
    width="133px"
    {...props}
  />
);

export default Logo;
